var map = {
	"./integrations-bigcommerce.png": "27ff",
	"./integrations-drupal.png": "9e0b",
	"./integrations-google.png": "bb4e",
	"./integrations-gtm.png": "493e",
	"./integrations-klaviyo.png": "90f0",
	"./integrations-magento.png": "e259",
	"./integrations-manual.png": "431d",
	"./integrations-prestashop.png": "efb2",
	"./integrations-shopify.png": "c5d9",
	"./integrations-squarespace.png": "c47e",
	"./integrations-threedcart.png": "f328",
	"./integrations-wix.png": "4230",
	"./integrations-wordpress-wtd.png": "85b5",
	"./integrations-wordpress.png": "2943"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12c0";